import { Capacitor } from '@capacitor/core';
import { environment } from '../../../environments/environment';
import { OpenIdConfiguration } from '../../oidc/oidc-security.service';

function getRedirectUrl(webUrl: string, nativeUrl: string): string {
  if (!Capacitor.isNativePlatform()) {
    return webUrl;
  } else {
    return nativeUrl;
  }
}

export const openIdConfigurationNormal: OpenIdConfiguration = {
  type: 'normal',
  ...environment.oidcConf.normal,
  redirectUrl: getRedirectUrl(window.location.origin + '/', environment.redirectUrlCapacitorNormal),
};

export const openIdConfigurationSensible: OpenIdConfiguration = {
  type: 'sensible',
  ...environment.oidcConf.sensitive,
  redirectUrl: getRedirectUrl(window.location.origin + '/', environment.redirectUrlCapacitorSensible),
};
